import {
  FORECAST_ADHERENCE,
  FORECAST_ADHERENCE_REPORT,
  FORECAST_FILTERS_BY_PART,
  FORECAST_FILTERS_BY_VENDOR,
  FORECAST_LOCATION,
  FORECAST_PART_DETAILS,
  FORECAST_VENDOR_DETAILS,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

//division, department, vendor, part_no
export const getForecastAdherence = (
  aggr,
  forecastColumn = "n+1",
  startDate,
  endDate,
  division,
  department,
  vendor,
  parts,
  location,
  page,
  limit,
  sort = "desc"
) => {
  const requestURL = FORECAST_ADHERENCE;
  let obj = {
    aggregate_column: aggr,
    forecast_column: forecastColumn,
    start_date: startDate,
    end_date: endDate,
  };

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  if (parts && parts.length) {
    obj["part_list"] = parts.join(",");
  }

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit, sort_order: sort },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getForecastAdherenceReport = (
  startDate,
  endDate,
  forecastColumn = "n+1",
  division,
  department,
  vendor,
  parts,
  requestId
) => {
  const requestURL = FORECAST_ADHERENCE_REPORT;
  let obj = {
    start_date: startDate,
    end_date: endDate,
    forecast_column: forecastColumn,
    request_id: requestId,
  };

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  if (parts && parts.length) {
    obj["part_list"] = parts.join(",");
  }
  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
};

export const getForecastDivisionDeptVendorByPart = (parts) => {
  const requestURL = FORECAST_FILTERS_BY_PART;
  let obj = {};

  if (parts && parts.length) {
    obj["part_list"] = parts.join(",");
  }
  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getForecastDivisionDeptByVendor = (vendor) => {
  const requestURL = FORECAST_FILTERS_BY_VENDOR;
  let obj = {};

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }
  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getForecastLocations = () => {
  const requestURL = FORECAST_LOCATION;

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: {},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getForecastVendorDetails = (
  divisionList = null,
  deptList = null,
  page,
  search
) => {
  let requestURL = FORECAST_VENDOR_DETAILS;
  let obj = {};
  if (divisionList && divisionList.length) {
    obj["division_list"] = divisionList.join(",");
  }

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (search) {
    obj["search"] = search;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getForecastPartDetails = (
  deptList = null,
  vendorList = null,
  page,
  search
) => {
  let requestURL = FORECAST_PART_DETAILS;
  let obj = {};
  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (vendorList && vendorList.length) {
    obj["vendor_list"] = vendorList.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (search) {
    obj["search"] = search;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
